<template>
    <ContainerLayout page="0" :padding="false">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div class="p-2 my-1">
                <div class="d-flex align-items-center mb-1">
                    <!-- <small style="font-size: 12px;">
                        {{ $t('Status') }}
                    </small> -->
                    <div class="ml-auto d-flex align-items-center">
                        <div v-if="transaction.status == 'PAYMENT'" class="badge badge-warning text-white"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Waiting for Payment') }}
                        </div>
                        <div v-if="transaction.status == 'PAID'" class="badge badge-main"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('On Processing') }}
                        </div>
                        <div v-if="transaction.status == 'COMPLETED'" class="badge badge-success"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Completed') }}
                        </div>
                        <div v-if="transaction.status == 'FAILED'" class="badge badge-danger"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Failed') }}
                        </div>
                        <div v-if="transaction.status == 'EXPIRED'" class="badge badge-danger"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Expired') }}
                        </div>
                        <div v-if="transaction.status == 'CANCELLED BY USER'" class="badge badge-danger"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Cancelled by user') }}
                        </div>
                        <div v-if="transaction.status == 'CANCELLED BY SYSTEM'" class="badge badge-danger"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Cancelled by system') }}
                        </div>
                        <div v-if="transaction.status == 'CANCELLED BY PROVIDER'" class="badge badge-danger"
                            style="font-weight: 600; font-size: 11px;">
                            {{ $t('Cancelled by provider') }}
                        </div>
                    </div>
                </div>
                <hr class="my-2 full-hr inside-row" style="border-top: 1.5px solid rgba(0,0,0,.1);">
                <div class="d-flex align-items-center mt-2 mb-1">
                    <small style="font-weight: 600; font-size: 12px;">
                        {{ $t('Invoice Number') }}
                    </small>
                    <div class="ml-auto d-flex align-items-center">
                        <small style="font-size: 12px;">
                            {{ transaction.invoice_number }}
                        </small>
                    </div>
                </div>
                <div class="d-flex align-items-center my-1 mb-3">
                    <div></div>
                    <div class="ml-auto d-flex align-items-center">
                        <router-link :to="{ path: '', query: { ...$route.query } }"
                            @click.prevent="openIframe(this.api_url + '/transaction/invoice/' + transaction.id + '?view=iframe', '{{ transaction.invoice_number }}')"
                            class="text-main" style="font-size: 12px; font-weight: 700;">
                            {{ $t('View Invoice Details') }}
                        </router-link>
                    </div>
                </div>
                <div class="d-flex align-items-center my-1">
                    <small style="font-weight: 600; font-size: 12px;">
                        {{ $t('Transaction Date') }}
                    </small>
                    <div class="ml-auto d-flex align-items-center">
                        <small style="font-size: 12px;">
                            {{ formatDateTime(transaction.created_at) }}
                        </small>
                    </div>
                </div>
                <div class="d-flex align-items-center my-1">
                    <small style="font-weight: 600; font-size: 12px;">
                        {{ $t('Customer ID') }}
                    </small>
                    <div class="ml-auto d-flex align-items-center">
                        <small style="font-size: 12px;">
                            {{ transaction.customer_id }}
                        </small>
                    </div>
                </div>
                <div class="d-flex align-items-center my-1">
                    <small style="font-weight: 600; font-size: 12px;">
                        {{ $t('Destination ID') }}
                    </small>
                    <div class="ml-auto d-flex align-items-center">
                        <small style="font-size: 12px;">
                            {{ transaction.branch_customer_id }}
                        </small>
                    </div>
                </div>
                <div v-if="(transaction.status == 'PAYMENT') || (transaction.status != 'PAYMENT' && transaction.payment_link)"
                    class="d-flex align-items-center my-1">
                    <div></div>
                    <div class="ml-auto d-flex align-items-center">
                        <router-link
                            :to="{ name: 'Payment', query: { from: 'transaction', data: this.$encryptString(transaction.id, 'encryptKey') } }"
                            class="text-main" style="font-size: 12px; font-weight: 700;">
                            {{ $t('View Payment Details') }}
                        </router-link>
                    </div>
                </div>
                <div v-if="transaction.has_vat">
                    <div class="d-flex align-items-center mt-3 mb-1">
                        <small style="font-weight: 600; font-size: 12px;">
                            {{ $t('VAT Tax Invoice Number') }}
                        </small>
                        <div class="ml-auto d-flex align-items-center">
                            <small style="font-size: 12px;">
                                {{ transaction.vat_number ?? $t('Not Available Yet') }}
                            </small>
                        </div>
                    </div>
                    <div v-if="transaction.vat_url" class="d-flex align-items-start mt-2 mb-1">
                        <div></div>
                        <div class="ml-auto d-flex flex-column align-items-end">
                            <router-link :to="{ path: '', query: { ...$route.query } }"
                                @click.prevent="openIframe(transaction.vat_url, '{{ transaction.invoice_number }}')"
                                class="text-main" style="font-size: 12px; font-weight: 700;">
                                {{ $t('View VAT Tax Invoice') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="transaction.has_pph">
                    <div class="d-flex align-items-start mb-1 mt-3">
                        <small style="font-weight: 600; font-size: 12px;">
                            {{ showPphUpload || !transaction.pph_number ?
                                $t('PPh 23 Tax Withholding') : $t('PPh 23 Tax Withholding Number') }}
                            <div v-if="showPphUpload">
                                <span style="font-weight: normal;">
                                    ( {{ $t('.pdf / images max 5MB') }} )
                                </span>
                            </div>
                        </small>
                        <div v-if="!showPphUpload" class="ml-auto d-flex align-items-center">
                            <small v-if="transaction.pph_number" style="font-size: 12px;">
                                {{ transaction.pph_number }}
                            </small>
                            <div v-else class="d-flex flex-column align-items-end">
                                <router-link :to="{ path: '', query: { ...$route.query } }"
                                    @click.prevent="openIframe(transaction.pph_url, '{{ transaction.invoice_number }}')"
                                    class="text-main" style="font-size: 12px; font-weight: 700;">
                                    {{ $t('View PPh 23 Tax Withholding') }}
                                </router-link>
                                <div v-if="transaction.has_pph && transaction.has_pph == 'customer' && transaction.pph_url">
                                    <router-link :to="{ path: '', query: { ...$route.query } }"
                                        @click.prevent="openPphUpload()" class="text-main"
                                        style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Reupload') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!showPphUpload && transaction.pph_url && transaction.pph_number"
                        class="d-flex align-items-start mt-2 mb-1">
                        <div></div>
                        <div class="ml-auto d-flex flex-column align-items-end">
                            <router-link :to="{ path: '', query: { ...$route.query } }"
                                @click.prevent="openIframe(transaction.pph_url, '{{ transaction.invoice_number }}')"
                                class="text-main" style="font-size: 12px; font-weight: 700;">
                                {{ $t('View PPh 23 Tax Withholding') }}
                            </router-link>
                            <div v-if="transaction.has_pph && transaction.has_pph == 'customer' && transaction.pph_url">
                                <router-link :to="{ path: '', query: { ...$route.query } }" @click.prevent="openPphUpload()"
                                    class="text-main" style="font-size: 12px; font-weight: 500;">
                                    {{ $t('Reupload') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <Form v-if="showPphUpload && transaction.has_pph && transaction.has_pph == 'customer'"
                        @submit="handlePph" :validation-schema="schema" autocomplete="off" enctype="multipart/form-data"
                        style="font-size: 12px;">
                        <div class="d-flex align-items-start mb-1 mt-2">
                            <div class="form-group mb-0" style="margin-top: 8.5px;">
                                <Field name="pph_upload" type="file" accept="application/pdf , image/*" class="file-input"
                                    @change="handleFileChange" />
                                <hr class="mt-2 mb-1">
                                <ErrorMessage name="pph_upload" class="error-feedback" />
                            </div>
                            <div class="ml-auto d-flex flex-column">
                                <button class="btn btn-sm btn-main btn-block mt-2" :disabled="loading"
                                    style="font-size: 12px; width: 100px;">
                                    <span>{{ $t('Upload') }}</span>
                                </button>
                                <button class="btn btn-sm btn-secondary btn-block mt-1" :disabled="loading"
                                    @click.prevent="closePphUpload()" style="font-size: 12px; width: 100px;"
                                    v-if="transaction.pph_url">
                                    <span>{{ $t('Cancel') }}</span>
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
            <hr class="my-0 full-hr" style="border-top: 7px solid rgba(0,0,0,.1);">
            <div class="p-2">
                <div class="mx-0">
                    <div class="mb-1 px-1">
                        <div class="row">
                            <div v-if="transaction.location_id || transaction.branch_id" class="col-lg-6 col-12">
                                <div class="mb-2">
                                    <small style="font-weight: 700; font-size: 12px;">
                                        {{ $t('Destination') }}
                                    </small>
                                </div>
                                <div class="card mb-4"
                                    style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                                    <div v-if="transaction.location_id" class="card-header p-1">
                                        <div class="d-flex align-items-center px-2 py-1">
                                            <small style="font-weight: 700; font-size: 12px;">
                                                {{ transaction.current_location_name + ' - ' +
                                                    (transaction.location_airport_code ?
                                                        transaction.location_airport_code + ', ' : '') +
                                                    transaction.location_city + ', ' +
                                                    transaction.location_province }}
                                            </small>
                                        </div>
                                    </div>
                                    <div v-if="transaction.branch_id" class="my-1 mx-2">
                                        <div class="my-1">
                                            <div v-if="transaction.branch_name || transaction.branch_brand"
                                                class="d-flex align-items-center">
                                                <small style="font-size: 12px; font-weight: 500;">
                                                    {{ transaction.branch_name }} <span
                                                        style="font-size: 11px; font-weight: 400;">{{
                                                            transaction.branch_brand ? ' - ' + transaction.branch_brand : ''
                                                        }}</span>
                                                </small>
                                            </div>
                                            <div v-if="transaction.branch_phone" class="d-flex align-items-center">
                                                <small class="text-muted" style="font-size: 12px;">
                                                    {{ transaction.branch_phone }}
                                                </small>
                                            </div>
                                            <div v-if="transaction.branch_address" class="d-flex align-items-center">
                                                <small class="text-muted" style="font-size: 12px;">
                                                    {{ transaction.branch_address }}
                                                </small>
                                            </div>
                                            <div v-if="transaction.branch_receiver_name || transaction.branch_receiver_phone"
                                                class="d-flex align-items-center">
                                                <small style="font-size: 12px;">
                                                    {{ $t('PIC') }} : {{ transaction.branch_receiver_name }}
                                                    ({{ transaction.branch_receiver_phone }})
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="mb-2">
                                    <small style="font-weight: 700; font-size: 12px;">
                                        {{ $t('Total Details') }}
                                    </small>
                                </div>
                                <div class="card mb-4"
                                    style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                                    <div class="my-1 mx-2">
                                        <div class="d-flex align-items-center my-1">
                                            <small style="font-size: 12px; font-weight: 500;">
                                                {{ $t('Subtotal') }}
                                            </small>
                                            <div class="ml-auto d-flex align-items-center">
                                                <small style="font-size: 12px;">
                                                    {{ transaction.original_amount_formatted }}
                                                </small>
                                            </div>
                                        </div>
                                        <div v-for="(transaction_fee, index) in transaction.transaction_fees" :key="index">
                                            <div v-if="transaction_fee.fee_operation != 'none'">
                                                <div class="d-flex align-items-center my-1">
                                                    <small style="font-size: 12px; font-weight: 500;">
                                                        {{ transaction_fee.current_fee_name +
                                                            (transaction_fee.fee_value_type == 'percentage' ? ' (' +
                                                                transaction_fee.fee_label + ')' : '') }}
                                                    </small>
                                                    <div class="ml-auto d-flex align-items-center">
                                                        <small v-if="transaction_fee.amount != null"
                                                            style="font-size: 12px;"
                                                            :class="{ 'text-danger': transaction_fee.fee_operation == 'subtract' && transaction_fee.amount > 0 }">
                                                            {{ transaction_fee.fee_operation == 'subtract' &&
                                                                transaction_fee.amount > 0 ? '- ' : '' }}
                                                            {{ transaction_fee.amount_formatted }}
                                                        </small>
                                                        <small v-else style="font-size: 12px;"
                                                            :class="{ 'text-danger': transaction_fee.fee_operation == 'subtract' && calculatedFee(transaction_fee) > 0 }">
                                                            {{ transaction_fee.fee_operation == 'subtract' &&
                                                                calculatedFee(transaction_fee) > 0 ? '- ' : '' }}
                                                            Rp. {{ formatCurrency(calculatedFee(transaction_fee)) }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center my-1">
                                            <small style="font-size: 12px; font-weight: 500;">
                                                {{ $t('Transaction Fee') }}
                                            </small>
                                            <div class="ml-auto d-flex align-items-center">
                                                <small style="font-size: 12px;">
                                                    {{ transaction.transaction_fee != null ?
                                                        transaction.transaction_fee_formatted : '-' }}
                                                </small>
                                            </div>
                                        </div>
                                        <div v-if="transaction.calculate_stamp_duty && transaction.stamp_duty > 0"
                                            class="d-flex align-items-center my-1">
                                            <small style="font-size: 12px; font-weight: 500;">
                                                {{ $t('Stamp Duty') }}
                                            </small>
                                            <div class="ml-auto d-flex align-items-center">
                                                <small style="font-size: 12px;">
                                                    {{ transaction.stamp_duty != null ? transaction.stamp_duty_formatted :
                                                        '-' }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-footer p-1">
                                        <div class="d-flex align-items-center m-1">
                                            <small class="font-weight-bold" style="font-size: 12px;">
                                                {{ $t('Total') }}
                                            </small>
                                            <div class="ml-auto d-flex align-items-center">
                                                <small class="font-weight-bold" style="font-size: 12px;">
                                                    {{ transaction.amount != null ?
                                                        transaction.amount_formatted : 'Rp. ' +
                                                        formatCurrency(transaction.calculated_amount) }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(item, key) in transaction.transaction_products" :key="key" class="mb-1 px-1">
                        <hr class="mt-0 mb-2 full-hr inside-row-second" style="border-top: 7px solid rgba(0,0,0,.1);">
                        <div :class="key == 0 ? 'mb-2' : 'mt-2 mb-2'">
                            <small style="font-weight: 700; font-size: 12px;">
                                {{ $t('Product') }} #{{ key + 1 }}
                            </small>
                        </div>
                        <div class="card mb-4"
                            style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                            <div class="card-header p-1">
                                <div class="d-flex align-items-center px-2 py-1">
                                    <div class="d-flex flex-column">
                                        <small style="font-weight: 700; font-size: 12px;">
                                            {{ item.current_product_name }}
                                        </small>
                                        <small class="text-muted" style="font-size: 11px;">
                                            {{ item.current_product_category_name }}
                                        </small>
                                    </div>
                                    <div class="ml-auto d-flex align-items-center">
                                        <img :src="item.product_image_url" style="width: auto; height: 30px;">
                                    </div>
                                </div>
                            </div>
                            <div class="my-1 mx-2">
                                <small style="font-weight: 700; font-size: 12.5px;">
                                    {{ $t('Product Details') }}
                                </small>
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Provider') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center">
                                        <small style="font-size: 12px;">
                                            {{ item.provider_name }}
                                        </small>
                                    </div>
                                </div>
                                <div v-if="item.product_detail_type == 'duration' || item.product_detail_type == 'category'"
                                    class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ item.product_detail_type == 'duration' ? $t('Duration') :
                                            $t('Category') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center">
                                        <small style="font-size: 12px;">
                                            {{ item.product_detail_detail_label }}
                                        </small>
                                    </div>
                                </div>
                                <div v-if="item.product_custom && item.product_custom.length > 0">
                                    <div v-if="item.api_response_formatted">
                                        <div class="d-flex align-items-center my-1"
                                            v-for="(response, index_response) in item.api_response_formatted"
                                            :key="index_response">
                                            <small style="font-size: 12px; font-weight: 500;">
                                                {{ $t(response['name']) }}
                                            </small>
                                            <div class="ml-auto d-flex align-items-center">
                                                <small style="font-size: 12px;">
                                                    {{ response['value'] }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="item.show_refresh_api && (transaction.status == 'PAID' || transaction.status == 'COMPLETED')"
                                            class="card mt-2">
                                            <div class="p-2 d-flex align-items-center justify-content-center flex-column">
                                                <div @click.prevent="refreshApi(item.id)" :disabled="isSpinning"
                                                    style="width: 40px; height: 40px; border-radius: 50%; background-color: #f5f5f5; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                                    <font-awesome-icon icon="refresh" class="text-main"
                                                        :class="{ 'spin-animation': isSpinning }" />
                                                </div>
                                                <div class="mt-2 text-center" style="font-weight: 600; font-size: 11px;">
                                                    {{ $t('Something went wrong, click to try again!') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center my-1">
                                    <small style="font-size: 12px; font-weight: 500;">
                                        {{ $t('Price') }}
                                    </small>
                                    <div class="ml-auto d-flex align-items-center">
                                        <small style="font-size: 12px;">
                                            {{ item.product_detail_price_formatted }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div v-if="(item.mikrotik_billing_transaction || item.product_additional_process) && (transaction.status == 'PAID' || transaction.status == 'COMPLETED')"
                                class="card-footer p-1">
                                <div v-if="item.mikrotik_billing_transaction"
                                    class="w-100 d-flex align-items-center justify-content-center my-2">
                                    <router-link
                                        :to="{ name: 'Service Details', query: { id: item.mikrotik_billing_transaction.mikrotik_billing_id } }"
                                        class="w-100 btn btn-sm btn-secondary">
                                        {{ $t('View Service Details') }}
                                    </router-link>
                                </div>
                                <div v-if="item.product_additional_process"
                                    class="w-100 d-flex align-items-center justify-content-center my-2">
                                    <router-link :to="{ name: 'Status Details', query: { id: item.id } }"
                                        class="w-100 btn btn-sm btn-main">
                                        {{ $t('View Status Details') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div v-for="(addon, index_addon) in item.transaction_product_addons" :key="index_addon">
                            <div class="card my-4"
                                style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between;">
                                <div class="card-header p-1">
                                    <div class="mb-2 mx-1 badge badge-warning text-white"
                                        style="font-weight: 600; font-size: 11px;">
                                        {{ $t('Additional Bundle') }}
                                    </div>
                                    <hr class="my-0 full-hr" style="border-top: 1.5px solid rgba(0,0,0,.1);">
                                    <div class="d-flex align-items-center px-2 py-1">
                                        <div class="d-flex flex-column">
                                            <small style="font-weight: 700; font-size: 12px;">
                                                {{ addon.current_product_name }}
                                            </small>
                                            <small class="text-muted" style="font-size: 11px;">
                                                {{ addon.current_product_category_name }}
                                            </small>
                                        </div>
                                        <div class="ml-auto d-flex align-items-center">
                                            <img :src="addon.product_image_url" style="width: auto; height: 30px;">
                                        </div>
                                    </div>
                                </div>
                                <div class="my-1 mx-2">
                                    <small style="font-weight: 700; font-size: 12.5px;">
                                        {{ $t('Product Details') }}
                                    </small>
                                    <div class="d-flex align-items-center my-1">
                                        <small style="font-size: 12px; font-weight: 500;">
                                            {{ $t('Provider') }}
                                        </small>
                                        <div class="ml-auto d-flex align-items-center">
                                            <small style="font-size: 12px;">
                                                {{ addon.provider_name }}
                                            </small>
                                        </div>
                                    </div>
                                    <div v-if="addon.product_detail_type == 'duration' || addon.product_detail_type == 'category'"
                                        class="d-flex align-items-center my-1">
                                        <small style="font-size: 12px; font-weight: 500;">
                                            {{ addon.product_detail_type == 'duration' ? $t('Duration') :
                                                $t('Category') }}
                                        </small>
                                        <div class="ml-auto d-flex align-items-center">
                                            <small style="font-size: 12px;">
                                                {{ addon.product_detail_detail_label }}
                                            </small>
                                        </div>
                                    </div>
                                    <div v-if="addon.product_custom && addon.product_custom.length > 0">
                                        <div v-if="addon.api_response_formatted">
                                            <div class="d-flex align-items-center my-1"
                                                v-for="(response, index_response) in addon.api_response_formatted"
                                                :key="index_response">
                                                <small style="font-size: 12px; font-weight: 500;">
                                                    {{ $t(response['name']) }}
                                                </small>
                                                <div class="ml-auto d-flex align-items-center">
                                                    <small style="font-size: 12px;">
                                                        {{ response['value'] }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="addon.show_refresh_api" class="card mt-2">
                                                <div
                                                    class="p-2 d-flex align-items-center justify-content-center flex-column">
                                                    <div @click.prevent="refreshApi(addon.id)" :disabled="isSpinning"
                                                        style="width: 40px; height: 40px; border-radius: 50%; background-color: #f5f5f5; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                                        <font-awesome-icon icon="refresh" class="text-main"
                                                            :class="{ 'spin-animation': isSpinning }" />
                                                    </div>
                                                    <div class="mt-2 text-center"
                                                        style="font-weight: 600; font-size: 11px;">
                                                        {{ $t('Something went wrong, click to try again!') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center my-1">
                                        <small style="font-size: 12px; font-weight: 500;">
                                            {{ $t('Price') }}
                                        </small>
                                        <div class="ml-auto d-flex align-items-center">
                                            <small style="font-size: 12px;">
                                                {{ addon.product_detail_price_formatted }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="(addon.mikrotik_billing_transaction || addon.product_additional_process) && (transaction.status == 'PAID' || transaction.status == 'COMPLETED')"
                                    class="card-footer p-1">
                                    <div v-if="addon.mikrotik_billing_transaction"
                                        class="w-100 d-flex align-items-center justify-content-center my-2">
                                        <router-link
                                            :to="{ name: 'Service Details', query: { id: addon.mikrotik_billing_transaction.mikrotik_billing_id } }"
                                            class="w-100 btn btn-sm btn-outline-main">
                                            {{ $t('View Service Details') }}
                                        </router-link>
                                    </div>
                                    <div class="w-100 d-flex align-items-center justify-content-center">
                                        <router-link :to="{ name: 'Status Details', query: { id: addon.id } }"
                                            class="w-100 btn btn-sm btn-main">
                                            {{ $t('View Status Details') }}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">
            <div class="p-2 my-1">
                <div v-for="(item, index) in [1, 2, 3]" :key="index" class="w-100 mb-4 px-1">
                    <div class="skeleton-card" />
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import TransactionService from "@/services/transaction.service";
import moment from 'moment';
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
    name: "TransactionDetail",
    components: {
        ContainerLayout,
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            pph_upload: yup
                .mixed()
                .required(this.$t("Data is required!", { data: this.$t('PPh 23 Tax Withholding') })),
        });

        return {
            schema,
            loaded_data: false,
            loading: false,
            transaction: null,
            isSpinning: false,
            api_url: process.env.VUE_APP_BACKEND_URL,
            showPphUpload: false,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        if (!this.$route.query.id) {
            this.$router.push("/transaction");
        } else {
            this.loadData();
        }
    },
    methods: {
        goBack() {
            this.navigateBackOrHome();
        },

        loadData() {
            this.loading = true;
            let loader = this.$loading.show();
            TransactionService
                .show(this.$route.query.id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.transaction = response.data.data;
                        this.transaction.calculated_amount = this.transaction.original_amount + (this.transaction.transaction_fee ?? 0) + (this.transaction.invoice_fees ?? 0);
                        this.showPphUpload = this.transaction.has_pph && this.transaction.has_pph == 'customer' && !this.transaction.pph_url;
                        this.loaded_data = true;
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                            this.$router.push("/transaction");
                        });
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                        this.$router.push("/transaction");
                    });
                });
        },

        formatDateTime(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('DD MMM YYYY, HH:mm');
        },

        refreshApi(tx_product_id) {
            this.isSpinning = true;

            TransactionService
                .reloadExternalApi(tx_product_id)
                .then((response) => {
                    if (response.data.status == "success") {
                        window.location.reload();
                    } else {
                        this.$vueAlert.alert(this.$t('Data failed to load, please contact our support'), null, 'error');
                    }
                    this.isSpinning = false;
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        } else {
                            this.$vueAlert.alert(this.$t('Data failed to load, please contact our support'), null, 'error');
                            this.isSpinning = false;
                        }
                    } else {
                        this.$vueAlert.alert(this.$t('Data failed to load, please contact our support'), null, 'error');
                        this.isSpinning = false;
                    }
                });
        },

        openIframe(url, name) {
            let data = {
                url: url,
                name: name,
            }

            this.$router.push({
                name: "File Preview",
                query: {
                    data: this.$encryptString(JSON.stringify(data), 'encryptKey'),
                }
            });
        },

        calculatedFee(fee) {
            return fee.fee_value_type == 'percentage' ? (this.transaction.original_amount * fee.fee_value) / 100 : fee.fee_value;
        },

        formatCurrency(value) {
            // Here's a simple formatter. Depending on your needs, you might want to use a library like `currency.js`
            return parseFloat(value).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\.?0+$/, '').replace(',', '.');
        },

        handleFileChange(event) {
            let file = event.target.files[0];
            if (file) {
                const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'application/pdf'];
                if (!validTypes.includes(file.type)) {
                    this.$vueAlert.alert(this.$t('Please upload an image or PDF file'), this.$t('Invalid file format'), 'error');
                    event.target.value = "";
                    return;
                }

                if (file.size > 5000000) {
                    this.$vueAlert.alert(this.$t('Please upload a file with a maximum size of 5MB'), this.$t('File size is too large'), 'error');
                    event.target.value = "";
                    return;
                }

                // const reader = new FileReader();
                // reader.onload = (e) => {
                //     this.filePreview = e.target.result;
                // };
                // reader.readAsDataURL(file);
            } else {
                // this.filePreview = null;
            }
        },

        openPphUpload() {
            this.showPphUpload = true;
        },

        closePphUpload() {
            this.showPphUpload = false;
        },

        handlePph(data) {
            this.loading = true;
            let loader = this.$loading.show();

            TransactionService
                .update(this.transaction.id, data)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status == 'success') {
                        this.$vueAlert.alert(response.data.message, null, 'success').then(() => {
                            this.loadData();
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },
    },
};
</script>

<style scoped>
.full-hr {
    margin-left: -4px;
    margin-right: -4px;
}

.full-hr.inside-div {
    margin-left: -16px !important;
    margin-right: -16px !important;
}

.full-hr.inside-row {
    margin-left: -12px !important;
    margin-right: -12px !important;
}

.full-hr.inside-row-second {
    margin-left: -16px !important;
    margin-right: -16px !important;
}

@media (min-width: 768px) {
    .full-hr {
        margin-left: -4px;
        margin-right: -4px;
    }

    .full-hr.inside-div {
        margin-left: -16px !important;
        margin-right: -16px !important;
    }

    .full-hr.inside-row {
        margin-left: -12px !important;
        margin-right: -12px !important;
    }

    .full-hr.inside-row-second {
        margin-left: -16px !important;
        margin-right: -16px !important;
    }
}

.skeleton-card {
    width: 100%;
    height: 189.8px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>